import './App.css';
import './RunData.json'
import Dashboard from './dashboard';


function App() {
  return (
    <div className="App">
      <Dashboard/>
    </div>
  );
}

export default App;
